
export default class EventListeners {
	constructor() {
		this.listeners = {};
	}

	/**
	 * If not eventId set, generate generic ID
	 * @param {string} type event type key
	 * @param {string} eventId event id
	 */
	getEventId(type, eventId = null) {
		return eventId ?? type + (new Date()).getTime() + Math.random().toString(36);
	}
	/**
	 * Subscribe event on element and store data for unsubscribe
	 *
	 * @param {Element} element element where event occurs
	 * @param {string} type event type key
	 * @param {Function} functionRef to run while event occurs
	 * @param {string} eventId event id
	 */
	add(element, type, functionRef, eventId = null) {
		if (element && type && functionRef) {
			this.listeners[this.getEventId(type, eventId)] = {
				type: type,
				functionRef: functionRef,
				element: element,
			};
			element.addEventListener(type, functionRef);
		}
	}



	/**
	 * Unsubscribe event on element and delete stored data
	 * @param {string} eventId event id
	*/
	remove(eventId) {
		if (this.listeners[eventId] && this.listeners[eventId]) {
			const { element, type, functionRef } = this.listeners[eventId];
			if (element && type && functionRef) {
				element.removeEventListener(type, functionRef);
				delete this.listeners[eventId];
			}
		}
	}

	/**
	 * Unsubscribe all stored events and delete stored data
	*/
	removeAll() {
		Object.keys(this.listeners).forEach(eventId => {
			this.remove(eventId);
		});
	}
}